export const tempUnits = [
    {
        value: 0,
        label: "c"
    },
    {
        value: 1,
        label: "f"
    }
]